import { render, staticRenderFns } from "./TopPageNoticeContentBox.vue?vue&type=template&id=6adf2439&scoped=true&lang=pug&"
import script from "./TopPageNoticeContentBox.vue?vue&type=script&lang=ts&"
export * from "./TopPageNoticeContentBox.vue?vue&type=script&lang=ts&"
import style0 from "./TopPageNoticeContentBox.vue?vue&type=style&index=0&id=6adf2439&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf2439",
  null
  
)

export default component.exports